module.exports = __webpack_public_path__ + "img/whole_box4_bg.f4c6b959.jpg";